import React, { useContext } from 'react';
import style from './style.module.css';
import fileImage from '../../../../assets/imgs/fileTypes/fileImage.png';
import { AdminContext } from '../../context/AdminContext';

export default function FileContent({ item, path, chatBody }) {
  const {direction} = useContext(AdminContext)
  return (
    <div className={`${style.container} ${direction=="ltr" ? 'justify-start' : 'justify-end'} ${chatBody && 'justify-end'}`}>

      <div className={`flex flex-row justify-start items-center ${'rtl'}`}  >
      <a href={`${path}${item?.file?.name}`} 
          className={`mainTextColor ${style.link}`} 
                                      download
                                      target="_blank"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}>
        <p className={style.text}>{item?.file?.name}</p>
        </a>                <a href={`${path}${item?.file?.name}`} 
          className={`mainTextColor ${style.link}`} 
                                      download
                                      target="_blank"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}>
        <div className={`${style.image} mainBg`}>
          <img src={fileImage} />
        </div>
        </a>
      </div>

    </div>
  );
}
